// extracted by mini-css-extract-plugin
export default {"ai":"AccountInfoCard_ai__27Lvn","ai__line":"AccountInfoCard_ai__line__AwVhT","ai__copy":"AccountInfoCard_ai__copy__9puFA","ai__bank":"AccountInfoCard_ai__bank__zb44D"};